import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibCustomizeGalleryButton({
  sidePanelProps
}) {
  const handleOpenSidePanel = useCallback(() => {
    listingLibObserver.openCustomizeGallerySidePanel(sidePanelProps);
  }, [sidePanelProps]);
  return /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "crm-listing-customize-gallery-button",
    onClick: handleOpenSidePanel,
    size: "extra-small",
    use: "tertiary-extra-light",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.tableActions.customizeGallery"
    })
  });
}